import { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { Link } from "react-router-dom";

export const NavbarMobile = (props) => {

  const [width, setWidth] = useState("0%")
  const [w, setW] = useState("t")
  const links = [
    { name: "Home", to: "home" },
    { name: "Community", to: "community" },
    { name: "Breeds", to: "breeds" },
    { name: "Register Dog", to: "registration", id: "navbarDropdownMenuLink" },
    { name: "Sign Up", to: "sign_up" },
    { name: "Login", to: "login", onClick: props.toggle_login },
    { name: "Profile", to: "profile" },
  ];


  useEffect(() => {
    // setWidth("500")
    // console.log("width changing", width)
    if (props?.showMobileMenu == true) {
      setWidth("90%")
    }
    else {
      setWidth("0%")
    }
  }, [props?.showMobileMenu])

  return (
    <div className="mobile-menu "
      style={{
        width: width
      }}>

      <div className="  position-absolute
             px-4" style={{ right: "0" }}>

        <MdClose size={35}
          className="ml-auto"
          onClick={(e) => {
            props?.setShowMobileMenu((init) => !init)
            console.log('clicked')

          }
          }
        />

      </div>
      <div className="text-left
                  px-5 font-weight-bold
                  mobile-nav-link text-white">
        {links.map(({ name, to, id, onClick }) => {
          return (
            <div class="nav-item active mb-3">
              <Link
                class="nav-link text-white"
                
                to={`/${to}`}
                id={id}
                onClick={onClick}
              >
                {name}
              </Link>

            </div>
          );
        })}
      </div>

    </div>
  )
}